import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { queryClient as qc, querySetting } from 'keys/queryClient'
import { getAssessmentExecutionFetch } from 'store/middlewares/assessment.crud'
import { secretStorage } from 'config'
import { affiliationGroups } from 'keys'

// שקף 2 — פאנל הצד כשנבחר כרטיס "בתי ספר יסודיים"/"חטיבות ביניים": קריאה נפרדת עם
// grade_group ('elementary'/'middle'), בדיוק כמו הסינון "בשלב חינוך" במסך נתוני הביצוע המלא
// (utils/filtering.js) — כך שהמוסדות והמספרים זהים לחלוטין לתוצאה שם, ולא הערכה
// מבוססת שכבות בצד הלקוח. פעיל רק כש-gradeGroup קיים (enabled)
const useSlide2GradeGroupAffiliations = (assessmentFilters, gradeGroup) => {
    const semesterAndYear = assessmentFilters?.semester_and_year
    const { roleIndex } = useSelector(state => state.user)

    const schoolsGroup = useMemo(() => {
        const { user_data } = secretStorage.getItem("user") || {}
        const { affiliation_groups } = user_data?.[roleIndex]?.user_data || {}
        return affiliation_groups?.find(group => group.name === affiliationGroups.schools)
    }, [roleIndex])

    const filters = useMemo(() =>
        schoolsGroup ? { group: schoolsGroup } : {}
    , [schoolsGroup])

    const { data, isLoading } = useQuery({
        queryKey: [qc.assessmentExecution, filters, semesterAndYear, gradeGroup],
        queryFn: async ({ signal }) => {
            const { data } = await getAssessmentExecutionFetch({ ...filters, semester_and_year: semesterAndYear, grade_group: gradeGroup }, signal)
            return data
        },
        enabled: !!gradeGroup,
        ...querySetting
    })

    return useMemo(() => ({
        affiliations: data || [],
        isLoading
    }), [data, isLoading])
}

export default useSlide2GradeGroupAffiliations
